import { Actor, Scene } from "excalibur";
import { Resources } from "../Resources";
import createKozmanian from "./../beeTypes/kozmanian";
import {
  hiveState,
  gameState,
  playerState,
  inventoryState,
} from "./../state/stateManager";
import { goToScene } from "../main";
import logo from "./../../res/logo.png";
import { createNotification, randomizeNPCLocations, sendAlert } from "../utils";
import createMaryEllen from "../beeTypes/maryEllen";
import flowerBG from "./../../res/bg.png";
export class StartMenu extends Scene {
  constructor() {
    super();

    this.menu = document.getElementById("main-menu");
    this.showingSaved = false;
    this.playerName = "Kaison";
  }
  onInitialize(engine) {
    // let bg = Resources.FlowerBG.toSprite();
    // const screen = engine.screen;
    // console.log("screen: ", screen);
    // let bgActor = new Actor({
    //   x: 0,
    //   y: 0,
    //   width: screen.resolution.width,
    //   height: screen.resolution.height,
    // });
    // bgActor.anchor.setTo(0, 0);
    // bgActor.graphics.add("bg", bg);
    // bgActor.graphics.use("bg");

    // this.add(bgActor);
    Resources.MenuSong.stop();
    Resources.MenuSong.play(0.5);
  }
  onActivate() {
    //get old data

    this.gameObject = localStorage.getItem("gameObject");
    if (!this.gameObject) {
      this.gameObject = { slot1: {}, slot2: {}, slot3: {} };

      localStorage.setItem(
        "gameObject",
        JSON.stringify({ slot1: {}, slot2: {}, slot3: {} })
      );
    } else {
      this.gameObject = JSON.parse(this.gameObject);
    }

    this.menu.style.display = "flex";
    console.log("gameObject: ", this.gameObject.slot1.gameStart);
    this.menu.innerHTML = `
      <div id="flowerBG" style="background-image: url('${flowerBG}')"></div>
    <div id="saved-menu-contents">
    
  <img style="width:80%; margin-left:10%;margin-bottom:25px;"src="${logo}"/><h1 style="font-family:'gameboy';">Saved Games</h1>
    <div id="slot-1" class="saved-slot"><span>slot1</span><br/><p id="slot1Link">${
      this.gameObject.slot1.gameStart !== null &&
      this.gameObject.slot1.gameStart !== undefined
        ? `Player Name: ${this.gameObject.slot1.player.name}`
        : `Empty`
    }</p><a id="deleteSlot1" class="delete">X</a></div>
    <div id="slot-2" class="saved-slot"><span>slot2</span><p id="slot2Link">Upgrade</p><a id="deleteSlot2" class="delete">X</a></div>
    <div id="slot-3" class="saved-slot"><span>slot3</span><p id="slot3Link">Upgrade</p><a id="deleteSlot3" class="delete">X</a></div>
  </div>
    `;
    let slot1 = document.getElementById("slot1Link");
    let slot2 = document.getElementById("slot2Link");
    let slot3 = document.getElementById("slot3Link");
    let deleteSlot1 = document.getElementById("deleteSlot1");
    let deleteSlot2 = document.getElementById("deleteSlot2");
    let deleteSlot3 = document.getElementById("deleteSlot3");
    deleteSlot1.onclick = () => {
      const del = this.createConfirmation(
        "Are You Sure You Want To Delete Memory Slot 1?"
      ).then(() => {
        console.log("should delete");
        this.gameObject.slot1 = {};
        localStorage.setItem("gameObject", JSON.stringify(this.gameObject));
        this.onActivate();
      });

      console.log("clicked delete");
    };
    // deleteSlot2.onclick = () => {
    //   const del = this.createConfirmation(
    //     "Are You Sure You Want To Delete Memory Slot 2?"
    //   ).then(() => {
    //     console.log("should delete");
    //     this.gameObject.slot2 = {};
    //     localStorage.setItem("gameObject", JSON.stringify(this.gameObject));
    //     this.onActivate();
    //   });

    //   console.log("clicked delete");
    // };
    // deleteSlot3.onclick = () => {
    //   const del = this.createConfirmation(
    //     "Are You Sure You Want To Delete Memory Slot 3?"
    //   ).then(() => {
    //     console.log("should delete");
    //     this.gameObject.slot3 = {};
    //     localStorage.setItem("gameObject", JSON.stringify(this.gameObject));
    //     this.onActivate();
    //   });

    //   console.log("clicked delete");
    // };
    slot1.onclick = () => {
      console.log("clicked slot");
      let vari = "asdf";
      if (
        this.gameObject.slot1.gameStart !== null &&
        this.gameObject.slot1.gameStart !== undefined
      ) {
        //open saved game
        this.openSavedGame("slot1");
      } else {
        //create new game
        this.captureName("slot1");
      }
    };
    slot2.onclick = () => {
      sendAlert("Upgrade For More Saved Games!");
      // if (
      //   this.gameObject.slot2.gameStart !== null &&
      //   this.gameObject.slot2.gameStart !== undefined
      // ) {
      //   //open saved game
      //   this.openSavedGame("slot2");
      // } else {
      //   //create new game
      //   this.captureName("slot2");
      // }
    };
    slot3.onclick = () => {
      sendAlert("Upgrade For More Saved Games!");
      // if (
      //   this.gameObject.slot3.gameStart !== null &&
      //   this.gameObject.slot3.gameStart !== undefined
      // ) {
      //   //open saved game
      //   this.openSavedGame("slot3");
      // } else {
      //   //create new game
      //   this.captureName("slot3");
      // }
    };
  }
  createConfirmation(question) {
    console.log("inside createConfirmation");
    return new Promise((res, rej) => {
      let confirmation = document.getElementById("confirmation");
      confirmation.style.display = "flex";
      confirmation.innerHTML = `<p>${question}</p>
      <div style="display:flex;flex-direction:row;"><button id="confirmYes" class="menuButton">Yes</button><button id="confirmNo" class="menuButton">No</button></div>
      
      `;
      let confirmYes = document.getElementById("confirmYes");
      let confirmNo = document.getElementById("confirmNo");
      confirmYes.onclick = () => {
        confirmation.style.display = "none";
        res(true);
      };
      confirmNo.onclick = () => {
        confirmation.style.display = "none";
        rej(false);
      };
    });
  }
  captureName(slot) {
    this.menu.innerHTML = `<div id="flowerBG" style="background-image: url('${flowerBG}')"></div>
    <div id="menu-contents">
    <img style="width:80%; margin-left:10%;margin-bottom:25px;"src="${logo}"/>
    <h1>Enter Player Name</h1>
    <input id="name-text" type="text"/>
    <div class="warning" id="warning"></div>
    <button id="save-name" class="menu-button">Start Game</button>
  </div>
    `;
    let button = document.getElementById("save-name");
    button.onclick = (e) => {
      if (this.playerName === " ") {
        console.log("player name empty");
      } else if (this.playerName.length > 15) {
        console.log("player name too long");
      } else {
        console.log("should start game, player name good: ", this.playerName);

        this.startGame(slot);
      }
    };
    let nameInput = document.getElementById("name-text");
    nameInput.onchange = (e) => {
      console.log("changed name: ", e.target.value);
      this.playerName = e.target.value;
    };
  }

  openSavedGame(slot) {
    gameState.cancelGame();
    console.log("opening saved: ", this.gameObject);
    hiveState.setHives(this.gameObject[slot].hives);
    hiveState.setHomeYard1Positions(this.gameObject[slot].homeYard1Positions);
    inventoryState.setInventory(this.gameObject[slot].inventory);
    gameState.setCoins(this.gameObject[slot].coins);

    playerState.setContent(this.gameObject[slot].content);

    gameState.setGameStart(
      this.gameObject[slot].gameStart,
      false,
      this.gameObject,
      slot
    );
    randomizeNPCLocations();
    goToScene("home");
  }
  startGame(slot) {
    console.log("starting game");
    gameState.cancelGame();
    let now = new Date().getTime();
    let positions = hiveState.getHomeYard1Positions();

    let hive = createKozmanian(
      { x: 17 * 16, y: 11 * 16, yard: "home" },
      4,
      5,
      "grandpa1"
    );

    let hive2 = createKozmanian(
      { x: 21 * 16, y: 11 * 16, yard: "home" },
      8,
      6,
      "grandpa2"
    );
    let hive3 = createMaryEllen(
      { x: 25 * 16, y: 11 * 16, yard: "home" },
      3,
      5,
      "grandpa3"
    );
    hive.overallFrames.boxes = 2;
    hive.overallFrames.queenAccess = 20;
    hive.overallFrames.count = 20;

    hive2.birth = hive2.birth + 11;
    hive2.overallFrames.boxes = 3;
    hive2.overallFrames.queenAccess = 10;
    hive2.overallFrames.count = 30;
    hive2.honeyFrames.count = 1;
    hive3.birth = hive3.birth + 20;

    hiveState.setHomeYard1Positions(positions);
    playerState.setContent();
    inventoryState.setInventory();
    hiveState.setHives([hive, hive2, hive3]);

    let game = {
      gameStart: now,
      mode: "rpg",
      hives: [hive, hive2, hive3],
      active: true,
      homeYard1Positions: positions,
      apiaryName: "Kozzz",
      player: {
        name: this.playerName,
      },
    };

    this.gameObject[slot] = game;
    randomizeNPCLocations();
    localStorage.setItem("gameObject", JSON.stringify(this.gameObject));
    gameState.setGameStart(now, true, this.gameObject, slot);
    goToScene("gameIntro");
  }

  onDeactivate() {
    this.menu.style.display = "none";
    Resources.MenuSong.stop();
  }
}
